import { Group, Stack } from '@mantine/core';
import { ReactNode } from 'react';

import { PublicationHeader } from '@/module/Author/Publication/components/PublicationHeader';
import { Publication } from '@/module/Author/Publication/model/PublicationTypes';

import { Content } from '@/core/components';

import { BdiList, IdentifierLinks, Identifiers, LanguagePill, WosIndexList } from '@feature/utils';

interface PublicationTitleGroupProps {
  publication: Publication;
  authorsNo: number;

  editAction: ReactNode;
  deleteAction: ReactNode;
  content?: ReactNode;
  titlePre?: ReactNode;
}

export function PublicationContent({
  publication,
  authorsNo,
  editAction,
  deleteAction,
  content,
  titlePre,
}: PublicationTitleGroupProps) {
  const { language, identifiers, bdis, wosIndexes } = publication;

  return (
    <Content type="full">
      <Stack gap="xs">
        <PublicationHeader
          publication={publication}
          authorsNo={authorsNo}
          editAction={editAction}
          deleteAction={deleteAction}
          titlePre={titlePre}
        />
        <Group>
          <LanguagePill language={language} />
          {identifiers && <Identifiers identifiers={identifiers} />}
        </Group>
        {identifiers && <IdentifierLinks identifiers={identifiers} />}
        <BdiList bdis={bdis} />
        <WosIndexList indexes={wosIndexes} />
        {content}
      </Stack>
    </Content>
  );
}
